export const filterLabels: Record<string, string> = {
  leaveTypes: 'Leave Type',
  dateFrom: 'Date From',
  dateTo: 'Date To',
  totDays: 'Total no. of days',
  remarks: 'Remarks',
  ticketReimbursementRequired: 'Ticket Reimbursement Required',
  passportRequired: 'Passport Required',
  homeCountryContactNumber: 'Home Country Contact Number',
  replacementEmployeeNumber: 'Replacement Employee Number',
  statuses: 'Status',
  purposes: 'Purpose',
  placeOfTravel: 'Place of Travel',
  purposeOfTravel: 'Purpose of Travel',
  approvedTravelAmount: 'Approved Travel Amount',
  country: 'Country',
  sponsoredBy: 'Sponsored by',
  companyName: 'Company Name',
  subContractorName: 'Sub-contractor Name',
  supplierName: 'Supplier Name',
  purpose: 'Purpose (Reason)',
  requiredLanguage: 'Required Language',
  resignationDateFrom: 'Resignation Date From',
  resignationDateTo: 'Resignation Date To',
  lastWorkingDateFrom: 'Last Working Date From',
  lastWorkingDateTo: 'Last Working Date To',
  letterOfContent: 'Letter of Content',
  reason: 'Reason',
  workShift: 'Work Shift',
  currentLocation: 'Current Location',
  attendanceType: 'Request Type',
  location: 'Location',
  deptProject: 'Department/Project',
  company: 'Company',
  itemType: 'Item Type',
  simCardCreditLimit: 'SIM Card Credit Limit',
  contactNumber: 'Contact Number',
  emailId: 'Email ID',
  emailSignature: 'Email Signature',
  accessory: 'Accessories',
  userInformation: 'User Information',
  module: 'Module',
  accountsModule: 'Accounts Module',
  organization: 'Organization',
  project: 'Project',
  requiredRoles: 'Required Role',
  requestTypes: 'Request Type',
  empNumber: 'Employee Number',
  companies: 'Company',
  createdDateFrom: 'Created Date From',
  createdDateTo: 'Created Date To',
  cCenters: 'Cost Center',
  ccTypes: 'Cost Center Type',
  currencies: 'Currency',
  mrFor: 'MR For',
  warranties: 'Warranty',
  prFor: 'PR For',
  tenderAmount: 'Tender Amount',
  tenderExtensionType: 'Tender Extension Type',
  tenderFor: 'Tender For',
  classification: 'Classification',
  classifications: 'Classification',
  priority: 'Priority',
  tenderStatus: 'Status',
  // Contact page filter labels
  employeeNumber: 'Employee Number',
  employeeName: 'Employee Name',
  occupation: 'Occupation',
  extension: 'Extension',
  email: 'Email',
  mobile: 'Mobile',
  workLocation: 'Work Location',
  department: 'Department/Project',
};
